import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";

import { useLazyGetAllProjectRiskQuery, } from "store/slices/apis/projectRiskSlice";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";


const RiskListPopUp = (props) => {


    const { open, handleClose, data, columns, } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();

     const [filters, setFilters] = useState({
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: pageNumber,
            PageSize: pageSize,
            ProjectId: projectId,
            Status:data,
            Severity:"Critical"
        });

     const [trigger, { data: riskList, isFetching }] = useLazyGetAllProjectRiskQuery();

     useEffect(() => {
             trigger(filters);
         }, []);

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };

        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters)
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
        
    };

    const handlePageSizeChange = (newSize) => {
         setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isSuccess) {
    //         if (!addActionTrackerRes?.data?.status) {
    //             openNotification(addActionTrackerRes?.data?.message, 'success')
    //             handleClose();
    //         } else {
    //             openNotification(addActionTrackerRes?.data?.message, 'error')
    //         }
    //     }
    // }, [addActionTrackerRes?.isSuccess]);


    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isError) {
    //         if (addActionTrackerRes?.error?.data?.status == 'fail') {
    //             openNotification(addActionTrackerRes?.error?.data?.message, 'error')
    //         } else {
    //             openNotification('Something went wrong!', 'error')
    //         }
    //         // cancel();
    //     }
    // }, [addActionTrackerRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Risk Overview
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={columns}
                             data={riskList?.data || []}
                            createSortHandler={handleRequestSort}
                            loading={loading}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={riskList?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default RiskListPopUp;